/**
 * Filter Button Component
 * 
 * A reusable button to open filter drawers/panels
 * Used across exhibits (EX5, EX6, etc.)
 * 
 * UI States:
 * - Default: Outline (Grey border, grey icon)
 * - Active: Filled (Blue background, white icon) when filters are applied
 */

import React from 'react';
import { Button, Tooltip } from 'antd';
import { FilterOutlined, LoadingOutlined } from '@ant-design/icons';
import styled from 'styled-components';

const Badge = styled.span`
  position: absolute;
  top: 2px;
  right: 2px;
  width: 8px;
  height: 8px;
  background-color: #EF4444;
  border-radius: 50%;
  border: 1.5px solid white;
`;

const ButtonWrapper = styled.div`
  position: relative;
  display: inline-flex;
`;

export interface FilterButtonProps {
  onClick: () => void;
  title?: string;
  loading?: boolean;
  disabled?: boolean;
  hasActiveFilters?: boolean;
}

const FilterButton: React.FC<FilterButtonProps> = ({
  onClick,
  title,
  loading = false,
  disabled = false,
  hasActiveFilters = false,
}) => {
  const tooltipTitle = title || (hasActiveFilters ? 'Modify filters' : 'Filter');
  
  return (
    <Tooltip title={tooltipTitle}>
      <ButtonWrapper>
        <Button
          // Default: Outline (Grey) | Active: Filled (Blue)
          type={hasActiveFilters ? 'primary' : 'default'}
          icon={loading ? <LoadingOutlined spin /> : <FilterOutlined />}
          onClick={onClick}
          disabled={disabled || loading}
          style={{ width: 40, height: 40 }}
        />
        {hasActiveFilters && !loading && <Badge />}
      </ButtonWrapper>
    </Tooltip>
  );
};

export default FilterButton;
